module.exports = __webpack_public_path__ + "assets/bolt.970947ee.svg";